'use strict';

export default {
    capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    },

    nl2br(str) {
        var regex = /(\r\n|\n\r|\r|\n)/g;
        str = '' + str;

        return (str.split(regex).map((line, index) => {
            return (line.match(regex) ? document.createElement('BR').outerHTML : line);
        }).join(''));
    },


    encodeBackendUrl(str) {
        return str ? str.replace(/ /g, '+').replace(/&/g, '%26') : '';
    },
    encodeUrl(str) {
        return str ? str.replace(/&/g, '%26').replace(/ /g, '+').replace(/\//g, '%2F') : '';
    },

    decodeUrl(str) {
        return str ? str.replace(/%26/g, '&').replace(/\+/g, ' ').replace(/%2F/g, '/') : '';
    },

    /**
     * Removes a string in a query object’s value which
     * might have pipez.
     *
     * @arg1 needle:Object
     * @arg2 queryObject:Object
     * @arg3 exactMatch:Boolean => false
     *
     * @returns queryObject:Object
     *
     * @example ( { foo: 'foo' }, { foo: 'foo|bar|baz', baz: 'bar' } ) => { foo: 'bar|baz', baz: 'bar' }
     */
    removeFromPipedQuery( needle, queryObject, exactMatch = false ) {
        var _query = {...queryObject};
        var value  = '';

        Object.keys( needle ).map(( key )=>{
            value = _query[key];

            // only perform this on piped values
            if ( ! /\|/.test( value ) ) {
                return;
            }
            
            var newValue;
            if (exactMatch) {
                newValue = value.split('|').filter(component => component !== needle[key]);
            } else {
                newValue = value.split('|').map(component => component.replace(needle[key], ''));
            }
            _query[key] = newValue.filter(component => component !== '').join('|').replace(/\|{2,}/, '|').replace(/^\||\|$/, '');

            if ( _query[key].length === 0 ) {
                delete _query[key];
            }
        });

        return _query;
    }
};



// WEBPACK FOOTER //
// ./app/utils/strings.js